import { useQuery } from "react-query";
import { loggedInApiCall } from "../../axiosClient/userApi";
import { zodParseWithLog } from "../../apiErrorLogs";
import { TagType } from "../../../types/tag";
import { z } from "zod";

// Schéma Zod pour TagType
const TagTypeSchema: z.ZodSchema<TagType> = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    description: z.string().optional(),
    context: z.enum(["global", "product", "ingredient", "cms", "supplier", "organization", "packaging"]),
    color: z.string(),
    active: z.boolean(),
    required: z.boolean(),
    multiple: z.boolean(),
    sortOrder: z.number(),
    metadata: z.record(z.string(), z.any()).optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
    company: z
        .object({
            id: z.number(),
            name: z.string(),
        })
        .optional(),
    values: z.array(z.any()).optional(), // TagValue[] - éviter la référence circulaire
});

export const useGetOneTagType = (id: string | undefined) => {
    const query = useQuery({
        queryKey: ["getOneTagType", id],
        enabled: id !== undefined,
        queryFn: async (): Promise<TagType> => {
            const response = await loggedInApiCall.get(`/api/tag_types/${id}`);
            return response.data;
        },
        select: (tagType: TagType) => {
            return zodParseWithLog(tagType, TagTypeSchema, "getOneTagType");
        },
    });

    return {
        tagType: query.data,
        ...query,
    };
};
